
import { Options, Vue } from 'vue-class-component'
import { PropSync } from 'vue-property-decorator'
@Options({
  emits: ['update:completeScan'],
  name: 'ScannedValueInput',
})
export default class ScannedValueInput extends Vue {
  @PropSync('valueCode', { type: String }) _valueCode!: string

  completeScan() {
    this.$emit('update:completeScan')
  }
}
